<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom >location_city</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom >{{'main.dynamicData' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" style="display: none">
          <input id="search1" autocomplete="off" matInput #filter2 placeholder="{{'main.search' | translate}}">
        </mat-form-field>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" matInput #filter>
        </mat-form-field>
      </div>
      <!-- / SEARCH -->

      <button mat-raised-button
        (click)="newType()"
        class="add-product-button mat-white-bg my-12 mt-sm-0">
        <span>{{'dynamicData.new' | translate}}</span>
      </button>

    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">

      <mat-table class="products-table"
        #table [dataSource]="dynamicDatas"
        matSort
        [@animateStagger]="{value:'50'}"
        fusePerfectScrollbar>


        <!-- Name Column -->
        <ng-container cdkColumnDef="name">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'canton.name' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let organizationType">
            <p class="text-truncate">
              @if (organizationType.type === 'system') {
                <i class="material-icons">
                  settings_applications
                </i>
              }
              @if (organizationType.type !== 'system') {
                <i class="material-icons" >
                  people
                </i>
              }
            {{organizationType.name}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="text">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'dynamicData.text' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let organizationType">
            <p class="text-truncate">{{organizationType.text}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="description">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'dynamicData.systemDescription' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let organizationType">
            <p class="text-truncate">{{organizationType.description}}</p>
          </mat-cell>
        </ng-container>
        <!-- Image Column -->




        <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

        <mat-row *cdkRowDef="let organizationType; columns: displayedColumns;"
          class="product"
          matRipple
          (click)="editType(organizationType)">
        </mat-row>

      </mat-table>
      @if (dynamicDatas.filteredData.length === 0) {
        <div class="no-data-msg">
          <span class="mat-headline-6">{{'main.noData' | translate}}</span>
        </div>
      }
      <mat-paginator #paginator
        [length]="dynamicDatas.filteredData.length"
        [pageIndex]="0"
        [pageSize]="50"
        [pageSizeOptions]="[25, 50, 100]">
      </mat-paginator>

    </div>
    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</div>
